import api from '@pray/shared/utils/api';

import type { ListResponse, WarmupAudience, WarmupCampaign, WarmupEmailCampaign, WarmupEvent } from './types';

export async function getWarmupCampaign({
  artistId,
  warmupId,
}: {
  artistId: string;
  warmupId: string;
}): Promise<{ object: WarmupCampaign }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupId) throw new Error('Warmup ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupId}`;
  const response = await api.executeGetRequest<{ data: { object: WarmupCampaign } }>(url);
  return response.data.data;
}

// Shape returned by the standard `sendListResponse` envelope (no pagination).
type SimpleListEnvelope<T> = {
  responded_at: string;
  object: 'list';
  count?: number;
  data_count: number;
  data: T[];
};

export async function getWarmupAudiences({
  artistId,
  warmupId,
}: {
  artistId: string;
  warmupId: string;
}): Promise<WarmupAudience[]> {
  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupId}/audiences`;
  const response = await api.executeGetRequest<SimpleListEnvelope<WarmupAudience>>(url);
  return response.data.data;
}

export async function getWarmupEvents({
  artistId,
  warmupId,
  limit,
  offset,
  type,
}: {
  artistId: string;
  warmupId: string;
  limit?: number;
  offset?: number;
  type?: 'info' | 'alert' | 'error';
}): Promise<ListResponse<WarmupEvent>> {
  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupId}/events`;
  const params: Record<string, string | number> = {};
  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;
  if (type) params.type = type;
  const response = await api.executeGetRequest<{ data: ListResponse<WarmupEvent> }>(url, params);
  return response.data.data;
}

export async function getWarmupEmails({
  artistId,
  warmupId,
  limit,
  offset,
}: {
  artistId: string;
  warmupId: string;
  limit?: number;
  offset?: number;
}): Promise<ListResponse<WarmupEmailCampaign>> {
  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupId}/emails`;
  const params: Record<string, string | number> = {};
  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;
  const response = await api.executeGetRequest<{ data: ListResponse<WarmupEmailCampaign> }>(url, params);
  return response.data.data;
}
